import { useTranslation } from 'react-i18next';
import { Button } from '../inputs/button.component';
import { CommonDocumentService } from '@umanforge/common';


interface StorageBannerProps {
  /** Espace utilisé en Ko */
  usedKo: number;
  /** Quota total en Ko */
  totalKo: number;
  /** Espace disponible en Ko provenant du cloud (optionnel). Si présent, remplace le calcul `totalKo - usedKo`. */
  availableKo?: number;
  /** Vrai seulement quand l'utilisateur est à l'intérieur d'un dossier */
  canCreateFolder: boolean;
  onCreateFolder: () => void;
}

import FolderPlusIcon from '../icons/folder-plus.icon';
import { DriveIcon } from 'components/icons/drive.icon';
export function StorageBanner( { usedKo, totalKo, availableKo: availableProp, canCreateFolder, onCreateFolder }: StorageBannerProps ) {
  const { t } = useTranslation();
  const availableKo = availableProp !== undefined ? availableProp : Math.max( totalKo - usedKo, 0 );
  const percent = totalKo > 0 ? Math.min( Math.round( ( usedKo / totalKo ) * 100 ), 100 ) : 0;

  const barColor =
    percent >= 100 ? 'bg-red-500' :
      percent >= 80  ? 'bg-red-400' :
        'bg-red-500';

  return (
    <div className="flex items-center gap-6 w-full p-4 bg-white rounded-xl border border-gray-100 shadow-sm">

      {/* Icon + bar */}
      <div className="flex items-center gap-4 flex-1 min-w-0">
        <DriveIcon className="w-10 h-10 text-red-500 fill-current shrink-0" />

        <div className="flex flex-col gap-1 flex-1 min-w-0">
          <span className="text-sm font-semibold text-gray-800">{ t( 'translation:storage_space' ) }</span>

          <div className="w-full h-2.5 rounded-full bg-gray-200 overflow-hidden">
            <div
              className={ `h-full rounded-full transition-all duration-300 ${ barColor }` }
              style={ { width: `${ percent }%` } }
            />
          </div>

          <div className="flex justify-between items-center">
            <span className="text-sm font-medium text-red-500">
              { CommonDocumentService.getReadableFileSizeString( Math.max( usedKo ?? 0, 0 ) ) } { t( 'translation:used' ) }
            </span>
            <span className="text-sm text-gray-500">
              <span className="font-semibold text-gray-700">{ CommonDocumentService.getReadableFileSizeString( Math.max( availableKo ?? 0, 0 ) ) }</span>
              { ' ' }{ t( 'translation:available_on' ) }{ ' ' }
              { CommonDocumentService.getReadableFileSizeString( Math.max( totalKo ?? 0, 0 ) ) }
            </span>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="h-11 w-52 shrink-0" title={ canCreateFolder ? '' : t( 'translation:navigate_to_folder_to_create' ) }>
        <Button
          label={ t( 'translation:create_folder' ) }
          icon={ <FolderPlusIcon className="w-5 h-5 fill-white shrink-0" /> }
          color="#ef4444"
          colorHover="#dc2626"
          disable={ !canCreateFolder }
          onClick={ onCreateFolder }
        />
      </div>

    </div>
  );
}
